//pincode js

(function () {
  var PINCODE_TO_SAP_MAP = {};
  var GLOBAL_PINCODE_TO_SAP_MAP = {};
  var CONFIG_LOADED = false;
  var PRODUCT_SPECIFIC_CONFIG = { products: [], pincodeGroups: {} };

  function safeParseJson(value) {
    if (!value) return null;
    if (typeof value === "object") return value;

    if (typeof value !== "string") return null;

    try {
      return JSON.parse(value);
    } catch (err) {
      console.warn(
        "[Pincode Express] Unable to parse product-specific pincode config:",
        err,
      );
      return null;
    }
  }

  function normalizeProductSpecificConfig() {
    const config = safeParseJson(
      window.PINCODE_EXPERIMENT_CONFIG &&
        window.PINCODE_EXPERIMENT_CONFIG.productSpecificPincodeConfig,
    );
    const configObject = config && typeof config === "object" ? config : {};

    return {
      products: Array.isArray(configObject.products)
        ? configObject.products
        : [],
      pincodeGroups:
        configObject.pincodeGroups ||
        configObject.pincode_groups ||
        configObject.groups ||
        {},
    };
  }

  function loadExpressPincodeConfig() {
    const pincodeClustersData =
      window.PINCODE_EXPERIMENT_CONFIG &&
      window.PINCODE_EXPERIMENT_CONFIG.pincodeClusters;
    const hasClusterConfig =
      pincodeClustersData && Array.isArray(pincodeClustersData.clusters);

    PRODUCT_SPECIFIC_CONFIG = normalizeProductSpecificConfig();
    const hasCustomConfig =
      Array.isArray(PRODUCT_SPECIFIC_CONFIG.products) &&
      PRODUCT_SPECIFIC_CONFIG.products.length > 0;

    if (!hasClusterConfig && !hasCustomConfig) {
      console.error(
        "[Pincode Express] pincodeClusters data is not defined or invalid in window.PINCODE_EXPERIMENT_CONFIG.",
      );
      return;
    }

    if (hasClusterConfig) {
      pincodeClustersData.clusters.forEach(function (cluster) {
        if (!cluster.sap_code || !Array.isArray(cluster.pincodes)) return;

        cluster.pincodes.forEach(function (pincode) {
          PINCODE_TO_SAP_MAP[String(pincode)] = cluster.sap_code;
          GLOBAL_PINCODE_TO_SAP_MAP[String(pincode)] = cluster.sap_code;
        });
      });
    }

    if (PRODUCT_SPECIFIC_CONFIG.pincodeGroups) {
      const groups = PRODUCT_SPECIFIC_CONFIG.pincodeGroups;
      Object.keys(groups).forEach(function (groupName) {
        const groupObj = groups[groupName];
        if (
          groupObj &&
          !Array.isArray(groupObj) &&
          Array.isArray(groupObj.pincodes)
        ) {
          const sapCode = groupObj.sap_code || groupObj.sapCode;
          if (sapCode) {
            groupObj.pincodes.forEach(function (pincode) {
              PINCODE_TO_SAP_MAP[String(pincode)] = sapCode;
            });
          }
        }
      });
    }

    CONFIG_LOADED = true;
  }

  function getProductSpecificRule(productId) {
    const normalizedProductId = String(productId || "").trim();
    if (!normalizedProductId) return null;

    return (
      (PRODUCT_SPECIFIC_CONFIG.products || []).find(function (item) {
        return (
          String(item.variantId || "").trim() === normalizedProductId ||
          String(item.productId || "").trim() === normalizedProductId ||
          String(item.product_id || "").trim() === normalizedProductId ||
          String(item.sku || "").trim() === normalizedProductId ||
          String(item.id || "").trim() === normalizedProductId
        );
      }) || null
    );
  }

  // Returns all pincodes covered by a rule (supports both array and single group)
  function getRulePincodes(rule) {
    const groups = PRODUCT_SPECIFIC_CONFIG.pincodeGroups || {};

    // New schema: pincodeGroups is an array of group names
    if (Array.isArray(rule.pincodeGroups)) {
      return rule.pincodeGroups.reduce(function (acc, groupName) {
        const groupObj = groups[String(groupName).trim()];
        const groupPincodes = Array.isArray(groupObj)
          ? groupObj
          : groupObj && Array.isArray(groupObj.pincodes)
            ? groupObj.pincodes
            : [];
        groupPincodes.forEach(function (p) {
          acc.push(String(p).trim());
        });
        return acc;
      }, []);
    }

    // Old schema: pincodeGroup is a single string
    const groupName = String(
      rule.pincodeGroup || rule.pincode_group || rule.group || "",
    ).trim();
    if (!groupName) return [];
    const groupObj = groups[groupName];
    const groupPincodes = Array.isArray(groupObj)
      ? groupObj
      : groupObj && Array.isArray(groupObj.pincodes)
        ? groupObj.pincodes
        : [];
    return groupPincodes.map(function (p) {
      return String(p).trim();
    });
  }

  function getProductSpecificDeliveryContext(productId, pincode) {
    const normalizedPincode = String(pincode || "").trim();
    if (!normalizedPincode) return null;

    const rule = getProductSpecificRule(productId);
    if (!rule) return null;

    const pincodes = getRulePincodes(rule);
    if (!pincodes.includes(normalizedPincode)) return null;

    const deliveryType = String(
      rule.deliveryType || rule.delivery_type || "porter",
    )
      .trim()
      .toLowerCase();
    const label =
      deliveryType === "porter"
        ? "Porter"
        : deliveryType.charAt(0).toUpperCase() + deliveryType.slice(1);

    // Look up message template from DeliveryConfig by messageId.
    // If no messageId is specified on the rule, defaults to "porter_standard" (cutoff-based).
    const messageId = rule.messageId || rule.message_id || null;
    let pdpMessage, cartMessage;
    let badgeText = null;

    if (
      window.DeliveryConfig &&
      typeof window.DeliveryConfig.getPorterMessage === "function"
    ) {
      const msgs = window.DeliveryConfig.getPorterMessage(messageId);
      pdpMessage = msgs.pdpMessage;
      cartMessage = msgs.cartMessage;
      badgeText = msgs.badgeText || null;
    } else {
      // Fallback if DeliveryConfig not loaded yet
      const cutoffHour =
        window.DeliveryConfig && window.DeliveryConfig.CUTOFF_HOUR != null
          ? window.DeliveryConfig.CUTOFF_HOUR
          : 16;
      const cutoffMinute =
        window.DeliveryConfig && window.DeliveryConfig.CUTOFF_MINUTE != null
          ? window.DeliveryConfig.CUTOFF_MINUTE
          : 0;
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
      const isBeforeCutoff = now < cutoff;
      pdpMessage = isBeforeCutoff
        ? "Order by 4 PM for delivery today"
        : "Next day Delivery Available";
      cartMessage = isBeforeCutoff ? "Get It Today" : "Get It Tomorrow";
    }

    return {
      matched: true,
      isCustom: true,
      deliveryType: deliveryType,
      label: label,
      messageId: messageId,
      source: "product-specific",
      expressMessage: pdpMessage,
      cartMessage: cartMessage,
      badgeText: badgeText,
      standardMessage: `${label} Service Available for Your Location`,
    };
  }

  function getDeliveryContext(pincode, productId) {
    const customContext = getProductSpecificDeliveryContext(productId, pincode);
    if (customContext) return customContext;

    const sapCode = PINCODE_TO_SAP_MAP[String(pincode)];
    if (!sapCode) {
      return {
        matched: false,
        isCustom: false,
        deliveryType: null,
        label: null,
        source: "cluster",
        expressMessage: "Delivery within 2-3 working days",
        standardMessage: "Free delivery available at your pincode",
      };
    }

    const globalExpressEnabled =
      window.PINCODE_EXPERIMENT_CONFIG &&
      window.PINCODE_EXPERIMENT_CONFIG.enabled;
    if (!globalExpressEnabled) {
      return {
        matched: false,
        isCustom: false,
        deliveryType: null,
        label: null,
        source: "cluster",
        expressMessage: "Delivery within 2-3 working days",
        standardMessage: "Free delivery available at your pincode",
      };
    }

    const excludedSapCodes = (
      (window.PINCODE_EXPERIMENT_CONFIG &&
        window.PINCODE_EXPERIMENT_CONFIG.excludedSapCodes) ||
      ""
    )
      .split(",")
      .map(function (code) {
        return code.trim();
      })
      .filter(function (code) {
        return code.length > 0;
      });

    if (excludedSapCodes.includes(sapCode)) {
      return {
        matched: false,
        isCustom: false,
        deliveryType: null,
        label: null,
        source: "cluster",
        expressMessage: "Delivery within 2-3 working days",
        standardMessage: "Free delivery available at your pincode",
      };
    }

    return {
      matched: true,
      isCustom: false,
      deliveryType: null,
      label: null,
      source: "cluster",
      expressMessage: "Delivery within 2-3 working days",
      standardMessage: "Free delivery available at your pincode",
    };
  }

  // -----------------------------
  // Public helpers
  // -----------------------------
  function getCurrentProductId() {
    return (
      window.meta?.product?.id ||
      document
        .querySelector("[data-product-id]")
        ?.getAttribute("data-product-id") ||
      null
    );
  }

  function isExpressPincode(pincode, productId) {
    if (!productId) productId = getCurrentProductId();
    const deliveryContext = getDeliveryContext(pincode, productId);
    if (deliveryContext && deliveryContext.matched) {
      return true;
    }

    return false;
  }

  function isGlobalExpressPincode(pincode) {
    if (!pincode) return false;
    return !!GLOBAL_PINCODE_TO_SAP_MAP[String(pincode).trim()];
  }

  function getGlobalSapCodeForPincode(pincode) {
    if (!pincode) return null;
    return GLOBAL_PINCODE_TO_SAP_MAP[String(pincode).trim()] || null;
  }

  function getSapCodeForPincode(pincode, productId) {
    if (!productId) productId = getCurrentProductId();
    const customContext = getProductSpecificDeliveryContext(productId, pincode);
    if (customContext) {
      return null;
    }

    return PINCODE_TO_SAP_MAP[String(pincode)] || null;
  }

  function getDisplayMessage(pincode, productId, type) {
    const deliveryContext = getDeliveryContext(pincode, productId);
    if (!deliveryContext) return "Free delivery available at your pincode";

    if (type === "express") {
      return (
        deliveryContext.expressMessage || "Delivery within 2-3 working days"
      );
    }

    return (
      deliveryContext.standardMessage ||
      "Free delivery available at your pincode"
    );
  }

  function isReady() {
    return CONFIG_LOADED;
  }

  // -----------------------------
  // Expose globally
  // -----------------------------
  window.PincodeExpress = {
    isExpressPincode: isExpressPincode,
    isGlobalExpressPincode: isGlobalExpressPincode,
    getGlobalSapCodeForPincode: getGlobalSapCodeForPincode,
    getSapCodeForPincode: getSapCodeForPincode,
    getDeliveryContext: getDeliveryContext,
    getDisplayMessage: getDisplayMessage,
    isReady: isReady,
  };

  loadExpressPincodeConfig();
})();

///GA4 event send when user enter pincode

function firePincodeGAEvent(pincode, isEligible, source) {
  console.log("event fired", getCookie("utm_source_track"));
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pincode_entered",
    pincode: String(pincode),
    pincode_eligible: Boolean(isEligible),
    pincode_source: source,
    utm_source: getCookie("utm_source_track"),
    utm_medium: getCookie("utm_medium_track"),
    utm_campaign: getCookie("utm_campaign_track"),
    utm_term: getCookie("utm_term_track"),
    utm_content: getCookie("utm_content_track"),
  });
}
